// Libs
import React from 'react';
import { withRouter } from 'react-router';
import { Form, Alert } from 'react-bootstrap';

// Services
import AccountService from 'services/AccountService';
import { Link } from 'react-router-dom';

// Components
import Loader from 'components/common/Loader';

// Images
import logoImage from 'images/flip-logo.png';

//-------------------------------------------------------------------------------------------------------------------

class PasswordResetPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            isLoading: false,
            error: null,
            email: '',
            password: ''
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        let {
            email,
            token
        } = this.props.match.params;
        if (token == '_') {
            token = null;
        }
        
        this.setState({
            email,
            token,
            step: !!token ? 3 : 1
        });
    }

    //--------------------------------------------------------------------------------------------------------------------

    async onSubmit(e) {
        const {
            step,
            email,
            token,
            password
        } = this.state;
        
        e.preventDefault();

        if (step == 1) {
            this.setState({ isLoading: true });
            try {
                await AccountService.sendPasswordResetEmail(email);
                this.setState({
                    isLoading: false,
                    step: 2,
                    error: null
                });
            } catch (error) {
                this.setState({
                    isLoading: false,
                    error
                });
            }
        }

        else if (step == 3) {
            this.setState({ isLoading: true });
            try {
                await AccountService.confirmPasswordReset(token, password);
                this.setState({
                    isLoading: false,
                    step: 4,
                    error: null
                });
            } catch (error) {
                this.setState({
                    isLoading: false,
                    error
                });
            }
        }
    }

    //--------------------------------------------------------------------------------------------------------------------

    render() {
        const {
            step,
            isLoading,
            error
        } = this.state;

        if (isLoading) {
            return (
                <div className="login-panel">
                    <Loader />
                </div>
            );
        }

        return (
            <div className="login-panel">

                <img src={logoImage} />

                {error &&
                    <Alert color="danger">
                        {error}
                    </Alert>
                }

                {step == 1 && this.renderStep1()}
                {step == 2 && this.renderStep2()}
                {step == 3 && this.renderStep3()}
                {step == 4 && this.renderStep4()}

            </div>

        );
    }

    renderStep1() {
        const {
            email
        } = this.state;

        return (<>
            <p>Please enter your email address. We will send an email with a link that you can use to reset your password.</p>

            <form onSubmit={this.onSubmit}>

                <Form.Group className="mb-3">
                    <Form.Label className="form-label">Email Address</Form.Label>
                    <input
                        type="text"
                        className="form-control"
                        autoFocus
                        value={email || ''}
                        onChange={e => this.setState({ email: e.target.value })}
                    />
                </Form.Group>

                <div className="buttons d-flex">

                    <Link to="/" className="btn btn-secondary me-auto">
                        Cancel
                    </Link>

                    <button type="submit" className="btn btn-primary ms-auto">
                        Send email
                    </button>

                </div>

            </form>
        </>);
    }

    renderStep2() {
        return (<>

            <p>
                A link to reset your password has been emailed to you.<br/>
                Please follow the link to continue.
            </p>

        </>);
    }

    renderStep3() {
        const {
            password
        } = this.state;

        return (<>

            <p>Please enter your new password. Your new password must be at least 10 characters long.</p>
            
            <form onSubmit={this.onSubmit}>

                <Form.Group className="mb-3">
                    <Form.Label className="form-label">Password</Form.Label>
                    <input
                        type="password"
                        className="form-control"
                        autoFocus value={password || ''}
                        onChange={e => this.setState({ password: e.target.value })}
                    />
                </Form.Group>

                <div className="buttons d-flex">

                    <Link to="/" className="btn btn-secondary me-auto">
                        Cancel
                    </Link>

                    <button type="submit" className="btn btn-primary ms-auto">
                        Confirm
                    </button>

                </div>

            </form>
            
        </>);
    }

    renderStep4() {
        return (<>

            <p>Your password has been successfully changed.</p>

            <div className="buttons">

                <button type="button" className="button button-primary ms-auto btn-block" onClick={e => this.props.onComplete()}>
                    Continue
                </button>

            </div>

        </>);
    }
}

export default withRouter(PasswordResetPage);